'use strict';
const goldAsset = require('./gold-asset');
module.exports = function GoldAttachmentLocaliser(navigatorShim, resourceManager) {
	if (!navigatorShim || !resourceManager) {
		throw 'invalid-args';
	}
	const self = this;
	self.localiseSingleAttachment = function (idea, callOptions) {
		const attachment = idea && idea.attr && idea.attr.attachment,
			goldAssetId = attachment && attachment.goldAssetId,
			isGoldAsset = goldAssetId && goldAsset.isGoldAssetId(goldAssetId),
			assetUrl = isGoldAsset && resourceManager.getResource(goldAssetId);

		if (assetUrl) {
			if (callOptions && callOptions.sendSignedGoldAsserUrls) {
				attachment.content = assetUrl;
				attachment.remoteUrl = true;
				delete attachment.dataUriEncoded;
				delete attachment.goldAssetId;
				return Promise.resolve();
			} else {
				return navigatorShim.downloadAsDataUri(assetUrl)
				.then((dataUri) => {
					attachment.content = dataUri;
					attachment.dataUriEncoded = true;
					delete attachment.goldAssetId;
				}).catch(() => delete idea.attr.attachment);

			}
		}
	};
};
